var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 6h-3.008V4.182L9.489 0H2.992v6H0v8h3v3.1h11V14h3zM9.992 1.832 12.327 4H9.992zm-6-.832h5v4h4v1h-9zM13 16.1H4v-5h9zm3-3.1h-2v-2.9H3V13H1V7h15zm-4.994 0H5v-1h6.006zM9 15H5v-1h4zM3 9H2V8h1zm2 0H4V8h1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/print.svg";